import React from "react";
import PropTypes from "prop-types";

import DeltaLabel from "../DeltaLabel/DeltaLabel";

function Seats({ usedSeats, numSeats, deltaUsers, deltaSeats }) {
  return (
    <React.Fragment>
      {usedSeats}
      <DeltaLabel deltaQty={deltaUsers} />
      {" / "}
      {numSeats}
      <DeltaLabel deltaQty={deltaSeats} />
    </React.Fragment>
  );
}

Seats.propTypes = {
  usedSeats: PropTypes.number.isRequired,
  numSeats: PropTypes.number.isRequired,
  deltaUsers: PropTypes.number,
  deltaSeats: PropTypes.number,
};

Seats.defaultProps = {
  deltaUsers: 0,
  deltaSeats: 0,
};

export default Seats;
